import { jsx } from 'react/jsx-runtime';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

const DEFAULT_DELAY = 225;
function TooltipProvider({
  children,
  delayDuration = DEFAULT_DELAY,
  disableHoverableContent = true,
  ...rest
}) {
  return /* @__PURE__ */ jsx(
    TooltipPrimitive.Provider,
    {
      delayDuration,
      disableHoverableContent,
      ...rest,
      children
    }
  );
}

export { TooltipProvider };
//# sourceMappingURL=TooltipContext.mjs.map
